export default "__VITE_ASSET__5e52636e__"